var umami_was_init = false
export function umami_init_track() {
    if (umami_was_init) return
    async function trackElement(el: Element) {
        if (!globalThis.umami || !umami) return
        const evname = el.getAttribute('data-umami-event')
        if (!evname) return

        let eventData = {} as any

        for (let name of el.getAttributeNames()) {
            if (!name.startsWith('data-umami-event-')) continue
            const match = name.match(/data-umami-event-([\w-_]+)/)
            if (!match || !match[1]) continue
            eventData[match[1]] = el.getAttribute(name)
        }

        return umami.track(evname, eventData)
    }
    const onClick = async (e: MouseEvent) => {
        const el = e.target
        if (!(el instanceof HTMLElement)) return
        const parentElement = el.closest('a,button')
        if (!parentElement) return trackElement(el)

        trackElement(parentElement)
    }
    document.addEventListener('click', onClick, true)
    umami_was_init = true
}
